import { Flex, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { Link } from 'react-router-dom';

import { tKeys } from '@/i18n';

import ChevronLeftIcon from '@/assets/icons/components/ChevronLeft.icon';

import { RoutesEnum } from '@/enums/routes.enum';

import { useAppNav } from '@/hooks/useAppNav.hook';

export const BackButton = () => {
  const { isSecondaryPage } = useAppNav();

  return isSecondaryPage ? (
    <Flex
      alignItems='center'
      as={Link}
      justifyContent='center'
      to={RoutesEnum.home}
    >
      <ChevronLeftIcon fill='white' />
      <Text ml='5px'>{t(tKeys.back)}</Text>
    </Flex>
  ) : null;
};
